export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/ngrayk1l_IMG_6920.png";

// Real Trilogy Earthworks job photos
const IMG_TIGHT_ACCESS_MINI =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/dq47d1mx_IMG_6839.webp"; // Trilogy mini-excavator + motorised dumper in tight side-yard
const IMG_KOBELCO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/ihji31pp_IMG_6846.jpeg"; // Kobelco excavator on red dirt / rural trench
const IMG_BULK_PAD =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/m0xffr40_IMG_6847.webp"; // Wide bulk earthworks pad with CAT roller
const IMG_TRUCK_DUMPER =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/gzkmjj7t_IMG_6838.webp"; // Trilogy tipper truck + Cormidi tracked dumper at residential site
const IMG_WHEELBARROW_LEDGE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/akk3tqlm_IMG_6837.webp"; // Motorised wheelbarrow on retaining wall ledge
const IMG_CULVERT =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/p8r9fh6w_IMG_6921.webp"; // Humes box culvert install (Mount Morgan)

// New photos (Sep 2026 upload)
const IMG_PIER_HOLES =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/vymhb6th_IMG_6939.jpeg"; // Kobelco EX1429 + tipper truck + auger drilling pier holes at engineering building
const IMG_CULVERT_TRAILER =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/4gq85dix_IMG_6938.jpeg"; // Wider Humes culvert install with Trilogy branded trailer and wooden formwork
const IMG_TANK_PAD =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/jz8im9lf_IMG_6937.webp"; // Bobcat T590 tank pad prep on hilltop with tarp-covered base
const IMG_STORMWATER_TRENCH =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/qb3t4fq5_IMG_6934.jpeg"; // Bobcat E55Z digging stormwater trench along road with orange cones
const IMG_STORMWATER_PIPE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trilogy-earthworks/artifacts/vpcm6u25_IMG_6935.jpeg"; // Humes 450 class stormwater pipe installed in sandy trench

export const HERO_BG = "/kerb-chapter04.jpg";
export const MANIFESTO_IMG_1 = IMG_KOBELCO;
export const MACHINERY_1 = IMG_TIGHT_ACCESS_MINI;
export const AERIAL_ROAD = IMG_CULVERT;
// Chapter 04 — real Trilogy kerb & channel install (locally hosted + colour-graded)
export const STORMWATER_IMG = "/kerb-chapter04.jpg";

// New concrete / kerb & channel job photos (locally hosted + colour-graded)
export const CONCRETE_POOL = "/concrete-pool-surround.jpg";
export const CONCRETE_SHED_FORMWORK = "/concrete-shed-pad-formwork.jpg";
export const CONCRETE_CROSSOVER = "/concrete-driveway-crossover.jpg";
export const CONCRETE_RURAL_SLAB = "/concrete-rural-slab.jpg";
export const CONCRETE_REINFORCEMENT = "/concrete-reinforcement.jpg";

// Curated project gallery — real Trilogy Earthworks jobs across Central QLD
// Kerb & channel · Stormwater · Concrete leads the portfolio (priority services).
export const GALLERY = [
  {
    img: CONCRETE_CROSSOVER,
    title: "Concrete Driveway Crossover",
    type: "Concrete · Residential Crossover",
    year: "2026",
    location: "Rockhampton",
  },
  {
    img: CONCRETE_RURAL_SLAB,
    title: "Bulk Concrete Slab — Rural",
    type: "Concrete · Bulk Slab Pour",
    year: "2026",
    location: "Central Queensland",
  },
  {
    img: CONCRETE_REINFORCEMENT,
    title: "Slab Reinforcement Set",
    type: "Concrete · Rebar & Mesh",
    year: "2026",
    location: "Rockhampton",
  },
  {
    img: CONCRETE_SHED_FORMWORK,
    title: "Kerb & Channel Formwork",
    type: "Civil · Kerb Formwork & Base",
    year: "2026",
    location: "Rockhampton",
  },
  {
    img: CONCRETE_POOL,
    title: "Pool Surround Pour",
    type: "Concrete · Residential Finish",
    year: "2026",
    location: "Rockhampton",
  },
  {
    img: IMG_CULVERT_TRAILER,
    title: "Precast Box Culvert Install",
    type: "Civil · Stormwater Drainage",
    year: "2026",
    location: "Mount Morgan",
  },
  {
    img: IMG_STORMWATER_TRENCH,
    title: "Roadside Pipe Removal",
    type: "Civil · Stormwater Rectification",
    year: "2026",
    location: "Mount Morgan",
  },
  {
    img: IMG_STORMWATER_PIPE,
    title: "Class 4 Stormwater Pipe Set",
    type: "Civil · Drainage Detail",
    year: "2026",
    location: "Mount Morgan",
  },
  {
    img: IMG_BULK_PAD,
    title: "Hilltop Bulk Cut & Fill",
    type: "Civil · Bulk Earthworks",
    year: "2026",
    location: "Central Queensland",
  },
  {
    img: IMG_PIER_HOLES,
    title: "Auger Piering — Engineering Precinct",
    type: "Commercial · Bored Piers",
    year: "2026",
    location: "Rockhampton",
  },
  {
    img: IMG_TRUCK_DUMPER,
    title: "Residential Site Prep",
    type: "Residential · Site Prep & Delivery",
    year: "2026",
    location: "Yeppoon",
  },
  {
    img: IMG_TANK_PAD,
    title: "Rural Windmill Pad Preparation",
    type: "Rural · Windmill Pad Prep",
    year: "2026",
    location: "Boulder Creek",
  },
  {
    img: IMG_TIGHT_ACCESS_MINI,
    title: "Tight-Access Side Yard",
    type: "Residential · Tight-Access Works",
    year: "2026",
    location: "Yeppoon",
  },
  {
    img: IMG_KOBELCO,
    title: "Rural Track Excavation",
    type: "Civil · Excavation & Trenching",
    year: "2026",
    location: "Boulder Creek",
  },
];

export const SERVICES = [
  { key: "kerb-channel", name: "Kerb & Channel", blurb: "Kerb, channel and layback to Australian civil standards — precise stringlines, clean finishes.", img: STORMWATER_IMG },
  { key: "stormwater", name: "Stormwater Management", blurb: "Precast culverts, class-4 pipe runs, sub-soil drainage and rectification.", img: IMG_CULVERT_TRAILER },
  { key: "concrete", name: "Concrete", blurb: "Slabs, driveways, crossovers, shed pads and pool surrounds — placed, screeded, finished.", img: CONCRETE_CROSSOVER },
  { key: "excavation", name: "Excavation", blurb: "Precise cut & fill, footings, trenches — Kobelco 14T on the ground.", img: IMG_KOBELCO },
  { key: "site-prep", name: "Site Preparation", blurb: "From raw block to ready-to-build in days.", img: IMG_TRUCK_DUMPER },
  { key: "land-clearing", name: "Land Clearing", blurb: "Vegetation, stumps and contour prep — cleanly done.", img: IMG_TANK_PAD },
  { key: "trenching", name: "Trenching", blurb: "Services, drainage and utility trenches to spec.", img: IMG_STORMWATER_TRENCH },
  { key: "bulk-earthworks", name: "Bulk Earthworks", blurb: "Large-scale cut, fill and compaction with survey precision.", img: IMG_BULK_PAD },
  { key: "demolition", name: "Demolition", blurb: "Controlled strip-outs and full-site demolitions.", img: IMG_WHEELBARROW_LEDGE },
  { key: "road-works", name: "Road Works", blurb: "Access tracks, driveways, hardstands and haul roads.", img: IMG_STORMWATER_TRENCH },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Kerbs & stormwater.",
    body:
      "We install kerb, channel and stormwater to Australian civil standards — precise stringlines, correct falls, and clean concrete finishes that hand traffic and rainfall exactly where the drawings intend. From residential entries to full roadside runs, the water goes where it should.",
    location: "",
  },
  {
    n: "02",
    title: "Stormwater, engineered.",
    body:
      "Precast box culverts set true, backfilled and compacted so stormwater runs the way the plans drew it. Every join sealed, every haunch keyed in — the kind of civil work that only shows itself in the next wet season, still holding.",
    location: "Mount Morgan 2026",
  },
  {
    n: "03",
    title: "Groundwork with intent.",
    body:
      "Every project begins buried — in survey plans, soil reports, and the quiet negotiation between design and land. Our Kobelco 14-tonne reads the ground before it moves it. Rockhampton-born, Central Queensland-tested.",
    location: "Boulder Creek 2026",
  },
  {
    n: "04",
    title: "Machinery, measured.",
    body:
      "Our fleet is deliberately chosen for the job — excavators, skid steers, and motorised wheelbarrows for tight-access work most crews can't reach. Modern telematics, licensed operators, and a maintenance discipline that keeps us moving when weather doesn't.",
    location: "Yeppoon 2026",
  },
];
